var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg208SmartphoneVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.667,
    height: 451.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 378.668,
    height: 378.668,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    ry: 213.823,
    rx: 213.741,
    id: "svg_5",
    cy: 225.795,
    cx: 224.459,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 79.636,
    y: 66.068,
    width: 188.48,
    height: 346.77,
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 144.087,
    y: 156.875,
    width: 183.064,
    height: 153.237,
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m312.78961,147.79891l-37.79645,0l0,-71.14432c0,-13.90045 -10.84264,-25.25775 -24.09912,-25.25775l-159.09082,0c-13.26521,0 -24.09911,11.3573 -24.09911,25.25775l0,323.41531c0,13.89588 10.83827,25.25775 24.09911,25.25775l159.09082,0c13.25212,0 24.09912,-11.36187 24.09912,-25.25775l0,-81.20717l37.79645,0c12.71086,0 23.04716,-10.7581 23.04716,-23.98617l0,-123.09148c0,-13.21435 -10.3363,-23.98617 -23.04716,-23.98617zm-166.89542,-78.19746l50.90016,0c1.60631,0 2.92454,1.36763 2.92454,3.05544c0,1.6741 -1.31823,3.05088 -2.92454,3.05088l-50.90016,0c-1.61068,0 -2.91145,-1.37678 -2.91145,-3.05088c0,-1.68781 1.30077,-3.05544 2.91145,-3.05544zm25.44789,343.11562c-6.64351,0 -12.05174,-5.65349 -12.05174,-12.64717c0,-6.97081 5.39513,-12.62887 12.05174,-12.62887s12.06484,5.65349 12.06484,12.62887c-0.00437,6.98911 -5.40822,12.64717 -12.06484,12.64717zm86.87205,-34.11762l-173.75282,0l0,-287.1479l173.75282,0l0,56.34736l-99.32536,0c-12.69776,0 -23.0297,10.77182 -23.0297,23.99989l0,123.09149c0,13.22349 10.33194,23.98616 23.0297,23.98616l13.91995,0l0,41.2348l39.35476,-41.2348l46.05065,0l0,59.723zm67.42602,-83.71374c0,7.33673 -5.75306,13.30126 -12.85054,13.30126l-104.83835,0l-24.93719,26.1268l0,-26.1268l-24.1253,0c-7.07565,0 -12.83308,-5.9691 -12.83308,-13.30126l0,-123.09148c0,-7.34131 5.7487,-13.31498 12.83308,-13.31498l153.90084,0c7.07565,0 12.85054,5.97367 12.85054,13.31498l0,123.09148zm-25.49591,-98.2637c0,3.65465 -2.64519,6.60489 -5.90584,6.60489l-116.48414,0c-3.25192,0 -5.90584,-2.95024 -5.90584,-6.60489c0,-3.63177 2.65392,-6.60031 5.90584,-6.60031l116.48414,0c3.25629,0 5.90584,2.96854 5.90584,6.60031zm0,35.81459c0,3.65922 -2.64519,6.61861 -5.90584,6.61861l-116.48414,0c-3.25192,0 -5.90584,-2.95939 -5.90584,-6.61861c0,-3.6272 2.65392,-6.58659 5.90584,-6.58659l116.48414,0c3.25629,-0.00457 5.90584,2.95482 5.90584,6.58659zm0,35.81459c0,3.65007 -2.64519,6.61403 -5.90584,6.61403l-116.48414,0c-3.25192,0 -5.90584,-2.96396 -5.90584,-6.61403c0,-3.64092 2.65392,-6.59117 5.90584,-6.59117l116.48414,0c3.25629,-0.00457 5.90584,2.95939 5.90584,6.59117z",
    id: "svg_3",
    fill: "#193351"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 161.96,
    y: 180.145,
    width: 146.776,
    height: 102.726,
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 79.636,
    y: 66.068,
    width: 188.48,
    height: 346.77,
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 144.087,
    y: 156.875,
    width: 183.064,
    height: 153.237,
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    transform: "rotate(28 198.84674072265616,302.2478332519531)",
    ry: 38.778,
    rx: 16.408,
    id: "svg_18",
    cy: 302.248,
    cx: 198.847,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m312.78961,147.79891l-37.79645,0l0,-71.14432c0,-13.90045 -10.84264,-25.25775 -24.09912,-25.25775l-159.09082,0c-13.26521,0 -24.09911,11.3573 -24.09911,25.25775l0,323.41531c0,13.89588 10.83827,25.25775 24.09911,25.25775l159.09082,0c13.25212,0 24.09912,-11.36187 24.09912,-25.25775l0,-81.20717l37.79645,0c12.71086,0 23.04716,-10.7581 23.04716,-23.98617l0,-123.09148c0,-13.21435 -10.3363,-23.98617 -23.04716,-23.98617zm-166.89542,-78.19746l50.90016,0c1.60631,0 2.92454,1.36763 2.92454,3.05544c0,1.6741 -1.31823,3.05088 -2.92454,3.05088l-50.90016,0c-1.61068,0 -2.91145,-1.37678 -2.91145,-3.05088c0,-1.68781 1.30077,-3.05544 2.91145,-3.05544zm25.44789,343.11562c-6.64351,0 -12.05174,-5.65349 -12.05174,-12.64717c0,-6.97081 5.39513,-12.62887 12.05174,-12.62887s12.06484,5.65349 12.06484,12.62887c-0.00437,6.98911 -5.40822,12.64717 -12.06484,12.64717zm86.87205,-34.11762l-173.75282,0l0,-287.1479l173.75282,0l0,56.34736l-99.32536,0c-12.69776,0 -23.0297,10.77182 -23.0297,23.99989l0,123.09149c0,13.22349 10.33194,23.98616 23.0297,23.98616l13.91995,0l0,41.2348l39.35476,-41.2348l46.05065,0l0,59.723zm67.42602,-83.71374c0,7.33673 -5.75306,13.30126 -12.85054,13.30126l-104.83835,0l-24.93719,26.1268l0,-26.1268l-24.1253,0c-7.07565,0 -12.83308,-5.9691 -12.83308,-13.30126l0,-123.09148c0,-7.34131 5.7487,-13.31498 12.83308,-13.31498l153.90084,0c7.07565,0 12.85054,5.97367 12.85054,13.31498l0,123.09148zm-25.49591,-98.2637c0,3.65465 -2.64519,6.60489 -5.90584,6.60489l-116.48414,0c-3.25192,0 -5.90584,-2.95024 -5.90584,-6.60489c0,-3.63177 2.65392,-6.60031 5.90584,-6.60031l116.48414,0c3.25629,0 5.90584,2.96854 5.90584,6.60031zm0,35.81459c0,3.65922 -2.64519,6.61861 -5.90584,6.61861l-116.48414,0c-3.25192,0 -5.90584,-2.95939 -5.90584,-6.61861c0,-3.6272 2.65392,-6.58659 5.90584,-6.58659l116.48414,0c3.25629,-0.00457 5.90584,2.95482 5.90584,6.58659zm0,35.81459c0,3.65007 -2.64519,6.61403 -5.90584,6.61403l-116.48414,0c-3.25192,0 -5.90584,-2.96396 -5.90584,-6.61403c0,-3.64092 2.65392,-6.59117 5.90584,-6.59117l116.48414,0c3.25629,-0.00457 5.90584,2.95939 5.90584,6.59117z",
    id: "svg_10",
    fill: "#193351"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 161.96,
    y: 180.145,
    width: 146.776,
    height: 102.726,
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.022239,200.186815c-17.680868,-31.084566 -56.841732,-41.735567 -87.463532,-23.785622c-30.624246,17.94415 -41.117929,57.691993 -23.433798,88.775317c17.678421,31.084566 56.838062,41.737223 87.460269,23.788934c30.624654,-17.950359 41.12323,-57.696133 23.43706,-88.778629l0.000001,0zm-29.838402,77.518313c-24.495727,14.360287 -55.826294,5.838989 -69.969847,-19.029905c-14.146815,-24.863927 -5.748851,-56.665017 18.747691,-71.018267c24.497358,-14.359459 55.826294,-5.838989 69.970662,19.029077c14.144776,24.867653 5.749259,56.662119 -18.748506,71.019095zm-2.560618,-47.66438l-33.527422,-19.847844c-3.055288,-1.810558 -5.519664,-0.363022 -5.502536,3.224152l0.171687,39.395998c0.015497,3.586346 2.51005,5.046301 5.57431,3.249816l33.270912,-19.497654c3.060997,-1.793173 3.067522,-4.713909 0.01305,-6.524468l-0.000001,0z",
    id: "svg_6",
    stroke: "null",
    fill: "#f03"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg208SmartphoneVideo);
export default __webpack_public_path__ + "static/media/208 Smartphone Video.044f194ed6e5b7cd602e8f2274739a73.svg";
export { ForwardRef as ReactComponent };